import { downDependencies, useContentHealth } from '../hooks/use-content-health';

import { HelpCallout } from './ui-kit/help-callout';

/** Support names for the dependencies readiness reports, shown only in the expandable details. */
const DEPENDENCY_LABELS: Record<string, string> = {
  clickhouse: 'ClickHouse',
  temporal: 'Temporal',
};

/**
 * Warns above every Content page when a backend dependency is DOWN, so a blank
 * table reads as an outage rather than "no data". Hidden when healthy, when a
 * dependency is merely `disabled`, and when readiness itself can't be read.
 */
export function ContentHealthBanner() {
  const { data } = useContentHealth();
  const down = downDependencies(data?.checks);
  if (down.length === 0) return null;

  const details = down.filter((check) => check.detail);

  return (
    // Same width and gutter as `ContentPage`, so the callout lines up with the page below it.
    <div className="mx-auto w-full max-w-[1600px] px-6 pt-6">
      <HelpCallout
        tone="error"
        title="Some content features are unavailable."
        {...(details.length > 0 && {
          details: (
            <ul className="flex flex-col gap-1">
              {details.map((check) => (
                <li key={check.name} className="break-words">
                  <span className="text-foreground font-medium">
                    {DEPENDENCY_LABELS[check.name.toLowerCase()] ?? check.name}:
                  </span>{' '}
                  {check.detail}
                </li>
              ))}
            </ul>
          ),
        })}
      >
        Some data services are down, so some tables may be empty.
      </HelpCallout>
    </div>
  );
}
